import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

import { ActionPollingConfig, PollingState } from './types';
import { GLOBAL_POLLING_SLICE_NAME } from './consts';

const initialState: PollingState = {
  activePolls: {},
  errors: {},
  data: {},
};

const globalPollingSlice = createSlice({
  name: GLOBAL_POLLING_SLICE_NAME,
  initialState,
  reducers: {
    startGlobalPolling: (state, action: PayloadAction<{ id: string; config: ActionPollingConfig<any, any> }>) => {
      const { id } = action.payload;
      state.activePolls[id] = true;
      delete state.errors[id];
    },

    stopGlobalPolling: (state, action: PayloadAction<{ id: string; reason?: string }>) => {
      const { id, reason } = action.payload;
      delete state.activePolls[id];

      if (reason) {
        state.errors[id] = reason;
      }
    },

    updateGlobalPollingData: (state, action: PayloadAction<{ id: string; data: any }>) => {
      state.data[action.payload.id] = action.payload.data;
    },

    clearGlobalPolling: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      delete state.activePolls[id];
      delete state.errors[id];
      delete state.data[id];
    },
  },
});

export const { startGlobalPolling, stopGlobalPolling, updateGlobalPollingData, clearGlobalPolling } =
  globalPollingSlice.actions;

export const globalPollingReducer: Reducer<PollingState> = globalPollingSlice.reducer;
